import { render, staticRenderFns } from "./CreateAgentFeedback.vue?vue&type=template&id=1d62124d&"
import script from "./CreateAgentFeedback.vue?vue&type=script&lang=ts&"
export * from "./CreateAgentFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports